import { gql } from '@apollo/client';
const GET_ORDERS = gql `
  query GetOrders(
    $orderBy: String
    $statuses: [String]
    $seasonId: ID
    $search: String
    $first: Int
    $after: String
  ) {
    me {
      id
      ordersCount(statuses: $statuses, seasonId: $seasonId, search: $search)
      orders(
        orderBy: $orderBy
        statuses: $statuses
        seasonId: $seasonId
        search: $search
        first: $first
        after: $after
      ) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            orderId
            orderDeliveryDate
            sumOfModelQuantities
            allModelsReady
            allComponentVariantsReady
            status
            createdDate
            modifiedDate
            season {
              id
              name
              workingSeason
            }
            correctedOrder {
              id
              orderId
              status
            }
            models {
              edges {
                node {
                  id
                  modelSpecificationNode {
                    id
                    itemCode
                  }
                }
              }
            }
            orderSuppliers {
              edges {
                node {
                  id
                  supplier {
                    id
                    code
                    shortName
                    fullName
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDERS;
